import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  SALES_POINT_GROUP_PATH,
  SALES_POINT_GROUP_ADD_PATH,
  SALES_POINT_GROUP_UPDATE_PATH,
} from "utils/constants/paths";

const SalesPointGroup = Loadable(React.lazy(() => import("./View")));
const SalesPointGroupAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const SalesPointGroupRoute: IRouteItem = {
  path: SALES_POINT_GROUP_PATH,
  iconName: "Element4",
  element: React.createElement(SalesPointGroup),
  name: "Sales Point Groups",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: SALES_POINT_GROUP_ADD_PATH,
      element: React.createElement(SalesPointGroupAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: SALES_POINT_GROUP_UPDATE_PATH,
      element: React.createElement(SalesPointGroupAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
